import { ACTION_TYPES } from "../actions";

const initialState = {
  notice: {},
};
export default function (state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.NOTICE_LOADED:
      return {
        ...state,
        notice: action.payload,
      };
    default:
      return state;
  }
}
